import { Grid } from "@material-ui/core";
import { Typography } from "@material-ui/core";
import { Button } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import '../../custom.css'

const GridHeaderComponent = withStyles({
  root: {
    //height:80,
    background: "var( --custom-header-primary-color)",
    borderRadius: "4px 4px 0px 0px"
  }
})(Grid);

const GridHeaderComponentSeconday = withStyles({
  root: {
    //height:80,
    background: '#9E9E9E'
  }
})(Grid);

const GridHeaderFilter = withStyles({
  root: {
    minHeight:80,
    // background: '#CDDE00'    
    background: "var(--custom-primary-color)",
    borderRadius: "0px 0px 4px 4px"
  }
})(Grid);

const TypographyHeaderTitle = withStyles({
  root: {
    fontFamily:'PT Sans',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: 32,
    lineHeight: '41px',
    letterSpacing: '-0.02em',
    textAlign: 'left',
    color: '#545454'
  }
})(Typography);

const TypographyHeaderTitleSecondary = withStyles({
  root: {
    fontFamily:'PT Sans',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: 15,
    lineHeight: '19px',
    letterSpacing: '-0.02em',
    color: '#FFFFFF'
  }
})(Typography);

const HeaderButton = withStyles({
  root: {
    fontFamily:'PT Sans',
    fontStyle: 'normal',
    fontWeight: 700,
    fontSize: 15,
    lineHeight: '26px',
    letterSpacing: '-0.02em',
    textAlign: 'center',
    color: '#FFFFFF'
  }
})(Button);

export { GridHeaderComponent, TypographyHeaderTitle, GridHeaderComponentSeconday, TypographyHeaderTitleSecondary, HeaderButton, GridHeaderFilter }


// WEBPACK FOOTER //
// ./src/components/common/HeaderComponentStyled.js